import * as React from "react";
import classnames from "classnames";
import { AutoSizer as _AutoSizer, AutoSizerProps, Table as _Table, TableProps } from "react-virtualized";
import { TableLoader } from "./TableLoader";
import { Empty } from "antd";

const AutoSizer = _AutoSizer as unknown as React.FC<AutoSizerProps>;
const Table = _Table as unknown as React.FC<TableProps>;

export interface TableCoreProps extends Omit<TableProps, "width" | "height" | "headerHeight" | "rowHeight"> {
  stretchHeight?: boolean;
  loading?: boolean;
  rowCount: number;
  rowHeight?: number;
}

export const TableCore = React.forwardRef<_Table, TableCoreProps>((props, ref) => {
  const { stretchHeight = true, loading, rowHeight = 40, ...restProps } = props;
  const clName = classnames({ "scrollable-table-container": stretchHeight });

  return (
    <div className={clName}>
      <TableLoader loading={loading} />
      <AutoSizer>
        {({ width, height }) => (
          <Table
            ref={ref}
            className={"scrollable-table"}
            headerClassName="scrollable-table-header"
            width={width}
            height={height}
            headerHeight={40}
            rowHeight={rowHeight}
            noRowsRenderer={() => <Empty style={{ marginTop: 20 }} />}
            {...(restProps as TableProps)}
          />
        )}
      </AutoSizer>
    </div>
  );
});
